import { Component, OnInit } from '@angular/core';
import { ImageConverterPipe } from '../../pipes/image-converter.pipe';
import { LanguageSelectorComponent } from '../language-selector/language-selector.component';
import { LanguageService } from '../../services/language/language.service';
import { TranslateModule } from '@ngx-translate/core';


@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [LanguageSelectorComponent,TranslateModule],
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
  currentLang = 'es';
  logoImages: { src: string, width: number }[] = [];
  logoSrcSet: string = '';

  constructor(private imageConverter: ImageConverterPipe, private languageService: LanguageService) { }


  ngOnInit(): void {
    this.currentLang = this.languageService.getCurrentLanguage();
    this.logoImages = [
      { src: this.imageConverter.transform('assets/img/Logo-01-small.png'), width: 300 },
      { src: this.imageConverter.transform('assets/img/Logo-01-medium.png'), width: 600 },
      { src: this.imageConverter.transform('assets/img/Logo-01-large.png'), width: 900 }
    ];

    this.logoSrcSet = this.logoImages
      .map(image => `${image.src} ${image.width}w`)
      .join(', ');

    this.addScrollEventListener();
    this.addToggleEventListener();
  }

  changeLang(lang: string): void {
    this.languageService.setLanguage(lang);
    this.currentLang = lang;
  }

  addScrollEventListener() {
    window.addEventListener('scroll', () => {
      const navbar = document.getElementById('navbar');
      const isMobile = window.innerWidth < 768;

      if (navbar && !isMobile) {
        if (window.scrollY > 50) {
          navbar.classList.add('scrolled');
        } else {
          navbar.classList.remove('scrolled');
        }
      }
    });
  }

  addToggleEventListener() {
    const navToggle = document.querySelector('.mobile-menu-button');
    const navMenu = document.querySelector('.mobile-menu');

    if (navToggle && navMenu) {
      navToggle.addEventListener('click', () => {
        navMenu.classList.toggle('hidden');
        const navbar = document.getElementById('navbar');
        if (navMenu.classList.contains('hidden')) {
          navbar?.classList.remove('bg-mobile-open');
        } else {
          navbar?.classList.add('bg-mobile-open');
        }
      });
    }
  }
}